import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { KeyValue } from '@angular/common';
import {
  NG_VALUE_ACCESSOR,
  ControlValueAccessor,
  FormControl,
} from '@angular/forms';
import { MatSelect } from '@angular/material/select';

@Component({
  standalone: false,
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: SelectComponent,
      multi: true,
    },
  ],
})

export class SelectComponent implements ControlValueAccessor {
  @Input() type = 'single';
  @Input() options: Array<KeyValue<number, string>>;
  @Input() placeholder: string;
  @Input() control: FormControl;
  @Input() hintText: string;
  @Input() isRequired: boolean = false;
  @Output() change = new EventEmitter<any>();
  @Output() search = new EventEmitter<any>();

  searchValue: string = '';

  @ViewChild('matSelect') matSelect: MatSelect;

  set value(val: string) {
    this.val = val;
  }

  hide = true;
  val = '';

  onChange: any = () => { };
  onTouch: any = () => { };

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState?(isDisabled: boolean): void { }

  onSelectionChange(event: any) {
    let value = event.value;
    this.change.emit(value);
    this.control.setValidators(null);
    this.searchValue = '';
  }

  onSearchInput(event: any) {
    let value = event.target.value;
    if (value !== '' && value !== null && value !== undefined) {
      this.matSelect.open();
      this.search.emit(value);
    } else {
      this.matSelect.close();
    }
  }
}

